// Guidance por categoria (Fase 3, spec §4.5): item legado é string; item novo é { category, title, text,
// scenario_ids }. Strings caem em communication_style sem título. Os rótulos vivem em POLARIS.GUIDANCE.CATEGORIES.*
// (en + pt_BR).
export const GUIDANCE_CATEGORIES = [
  'communication_style',
  'conversation_strategy',
  'situational',
  'business_context',
];

export const guidanceCategoryOf = item =>
  typeof item === 'object' &&
  item !== null &&
  GUIDANCE_CATEGORIES.includes(item.category)
    ? item.category
    : 'communication_style';

// A forma que os cards das páginas Orientações consomem (id = índice na lista do assistente).
export const guidanceToCard = (item, id) => ({
  id,
  content: typeof item === 'string' ? item : item?.text || '',
  title: typeof item === 'string' ? '' : item?.title || '',
  category: guidanceCategoryOf(item),
});

// Agrupa os cards pelas 4 categorias, na ordem fixa, sem grupo vazio.
export const groupGuidanceCards = cards =>
  GUIDANCE_CATEGORIES.map(category => ({
    category,
    items: cards.filter(card => card.category === category),
  })).filter(group => group.items.length > 0);

// A escrita preserva a forma: string legada continua string; hash ganha text novo sem perder category/scenario_ids.
export const guidanceWithEdit = (list, id, content) =>
  list.map((item, idx) => {
    if (idx !== id) return item;
    return typeof item === 'string' ? content : { ...item, text: content };
  });
